import { render, staticRenderFns } from "./JunketHeader.vue?vue&type=template&id=65f36ec0"
import script from "./JunketHeader.vue?vue&type=script&lang=js"
export * from "./JunketHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports